import MailApi from "../../scripts/api/mail.api";
import Global from "../../scripts/Global";
import VueSignals from "../../scripts/VueSignals";
import MainApi from "../../scripts/api/main.api";

export default {
    name: 'CPAdmin',    
    data (){
        return {
          session_id : '',
          mail_templates: Array(),
          active_mail_template: {},
          newEmail: false,
        }
      },                
    mounted(){    
        if(Global.isLoggedInCookie()){
            this.session_id = Global.getSessionIdCookie()
            MailApi.listTemplates(this.session_id).then(res => {
                if(res.data.result){                
                    this.mail_templates = res.data.mail_templates
                }else {
                    if(res.data.reason == "session_id_invalid" || res.data.reason == "user_has_no_access"){
                        window.location.href = window.location.href.slice(0, window.location.href.indexOf('/cpadmin'))
                    }
                }
            })  
        }else {
            window.location.href = window.location.href.slice(0, window.location.href.indexOf('/cpadmin'))
            Global.logout()
        }
        
    },
    methods: {
        loadMail(type){
            MailApi.loadTemplate(this.session_id, type).then(res => {
                if(res.data.result){    
                    this.active_mail_template = res.data.mail_template            
                    // this.mail_templates = res.data.mail_templates
                }
            })
        },
        updateMail(type){
            MailApi.loadTemplate(this.session_id, type).then(res => {
                if(res.data.result){    
                    this.active_mail_template = res.data.mail_template            
                    // this.mail_templates = res.data.mail_templates
                }
            })
        },
        UpdateEmail(){
            if(this.newEmail){
                this.active_mail_template.mail_type = this.active_mail_template.mail_type_new
                this.newEmail = false
            }
            MailApi.updateTemplate(this.session_id, this.active_mail_template).then(res => {
                console.log(res)
            })
        },
        CloneEmail(){
            this.newEmail = true
            this.active_mail_template.mail_type_new = ''
        },
        CreateEmail(){
            this.newEmail = true
            this.active_mail_template = {            
                "mail_type_new": '',
                "subject": '',
                "lang": "",          //(optional) language
                "text": '',
                "placeholders": [], 
                "html": ""
            }
        },
        RefreshUI(){
            MainApi.RefreshUI(this.session_id).then(res => {
                if(res.data.result){
                    alert("all sessions Refreshed")
                }
            })
        }
    }
}